import { render, staticRenderFns } from "./StartupProfile.vue?vue&type=template&id=2fd98efa&"
import script from "./StartupProfile.vue?vue&type=script&lang=js&"
export * from "./StartupProfile.vue?vue&type=script&lang=js&"
import style0 from "./StartupProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports